<template>
  <div v-if="hasPermission(permissions.propertyTypesList)">
    <content-header>{{ projectTenant() ? $t('apartmentTypes') : $t('propertyTypes') }}</content-header>
    <v-content>
      <BootstrapTable
          :rows="rows"
          :columns="columns"
          :config="config"
          :total-rows="totalRecords"
          :actions="actions"
          @on-change-query="onChangeQuery"
          @on-create="$router.push({name: 'propertyTypes.create'})"
          @on-multiple-delete="onMultipleDelete"
      >
        <template slot="empty-results">{{ $t('noResultsFound') }}</template>
        <template slot="pagination-info" slot-scope="props">
          <template v-if="props.currentPageRowsLength !== 0">{{totalRecords}} {{ $t('totalRecords') }}</template>
          <template v-else>{{ $t('noResultsFound') }}</template>
        </template>
        <template slot="controls" slot-scope="props">
          <control-buttons
              :props="props"
              edit-link="propertyTypes.edit"
              delete-link="propertyTypes/DELETE"
              v-on:successAction="loadData(true)"
          />
        </template>
        <template slot="attachment" slot-scope="props">
          <show-attachment :attachment="props.row.attachment" :title="props.row.attachment" />
        </template>
      </BootstrapTable>
      <is-loading v-if="isLoading" />
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import {PropertyType} from "@/models/PropertyType";
import IsLoading from "@/components/IsLoading";
import ControlButtons from "@/components/ControlButtons";
import {actions, permissions, serverParams, swalMixin, tableActions, tableConfigure} from "@/plugins/constants";
import BootstrapTable from "@/components/Table/BootstrapTable";
import ShowAttachment from "@/components/ShowAttachment";
import mixins from "@/mixins";

export default {
  name: "PropertyTypeList",
  components: {ShowAttachment, ControlButtons, IsLoading, 'v-content': Content, ContentHeader, BootstrapTable},
  data() {
    return {
      isLoading: false,
      model: new PropertyType(),
      columns: [],
      rows: [],
      actions: tableActions(this.hasPermission(permissions.buyContractsCreate)),
      totalRecords: 0,
      config: tableConfigure(mixins.projectTenant() === 'Candle' ? this.$t('apartmentTypesList') : this.$t('propertyTypesList')),
      serverParams: serverParams,
      selectedRows: [],
      permissions: permissions
    };
  },
  beforeMount() {
    this.columns  = this.model.getColumns();
  },
  methods: {
    loadData(reset = false) {
      if (reset) {
        serverParams._start   = 0
        serverParams._end     = 10
        serverParams._sort    = ''
        serverParams._order   = ''
        serverParams._search  = ''
      }
      this.isLoading = true;
      this.$store.dispatch('propertyTypes/GET_ALL', this.serverParams)
          .then((response) => {
            this.rows         = response.data
            this.totalRecords = parseInt(response.headers['x-total-count'])
            this.isLoading    = false
          })
          .catch(() => this.isLoading = false);
    },
    onChangeQuery(queryParams) {
      serverParams._start   = (queryParams.page - 1) * queryParams.per_page
      serverParams._end     = queryParams.page * queryParams.per_page
      serverParams._sort    = queryParams.sort[0] ? queryParams.sort[0].name : ''
      serverParams._order   = queryParams.sort[0] ? queryParams.sort[0].order : ''
      serverParams._search  = queryParams.global_search ?? ''
      this.loadData()
    },
    async onMultipleDelete() {
      if (this.selectedRows.length === 0) {
        swalMixin('error', 'noRows')
        return false;
      }
      if (await actions('propertyTypes/DELETE', this.selectedRows, 'delete')) {
        this.loadData();
      }
    },
  }
}
</script>
